import Vue from 'vue'
import Vuex from 'vuex'
import { doGet,doPost } from '@/api/common'
import { removeToken,getToken } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    setting: {
      bottom_information: {
        list: []
      },
      link: [],
      menus: [],
      sgin: []
    },
    userInfo: localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):{},
    name: "",
    img:"",
    money: "",
    masonry: '',
    loginState:false,  // 登录的状态
    loginOpen: false,  // 登录的弹窗是否开启
    paymentOpen: false,  // 充值的弹窗是否开启
    personalOpen: false, // 打开用户修改页
    isInit:false,  // 进入页面初始化
    voiceState: localStorage.getItem("voiceState")?(localStorage.getItem("voiceState")==1?true:false):true,
    cartState: localStorage.getItem("cartState")?(localStorage.getItem("cartState")==1?true:false):true,
  },
  mutations: {
    getId(state,obj) {
      state.name = obj.name
      state.img = obj.img
      state.money = obj.total_amount
      state.masonry = obj.masonry
      state.isInit = true
      state.userInfo = obj
      state.loginState = true
			localStorage.setItem('userInfo', JSON.stringify(obj))
    },
    getVoiceState(state,voiceState){
      state.voiceState = voiceState
			localStorage.setItem('voiceState', voiceState ? 1 : 0)
    },
    getCartState(state,cartState){
      state.cartState = cartState
			localStorage.setItem('cartState', cartState ? 1 : 0)
    },
    setLogout(state) {
      state.name = ''
      state.img = ''
      state.money = ''
      state.userInfo = {}
      state.loginState = false
      removeToken()
			localStorage.clear()
    },
    getMoney(state,money){
      state.money = money;
    },
    getMasonry(state,masonry){
      state.masonry = masonry;
    },
    getAboutMon(state, obj) {
      state.masonry = obj.masonry
      state.money = obj.total_amount
    },
    getLogin(state,loginOpen){
      state.loginOpen = loginOpen
    },
    setPaymentOpen(state, paymentOpen) {
      state.loginOpen = false
      state.paymentOpen = paymentOpen
      state.personalOpen = false
    },
    setPersonalOpen(state, personalOpen) {
      state.loginOpen = false
      state.paymentOpen = false
      state.personalOpen = personalOpen
    }
  },
  actions: {
    getInfo({ commit }){
			return new Promise((resolve, reject) => {
        doGet('/api/member.Member/info',).then(res => {
          console.log(res)
          if(res){
            commit('getId', res.data)
          }
					resolve(res)
				}).catch(err => {reject(err) })
			})
    },
    resetToken({ commit }) {
      return new Promise((resolve, reject) => {
        commit('setLogout')
				resolve()
			})
    },
    logout({ commit }){
			return new Promise((resolve, reject) => {
        doPost('/api/member.Logout/logout', {
          ApiToken:getToken()
        }).then(res => {
          commit('setLogout')
					resolve(res)
				  }).catch(err => {reject(err) })
			})
    },
  },
  modules: {
  },
  getters: {
    setting: state => state.setting,
    userInfo: state => state.userInfo,
    paymentOpen: state => state.paymentOpen,
    personalOpen: state => state.personalOpen,
    loginOpen: state => state.loginOpen
  }
})

//export default store
